'use strict';

var stringUnderscore = require('./stringUnderscore');

function stringSpacify(str) {
  return stringUnderscore(str).replace(/_/g, ' ');
}

module.exports = stringSpacify;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/string/internal/stringSpacify.js
// module id = 235
// module chunks = 0